import DefaultFactory from "/scripts/default/factory";
import CoreHero from "/components/core/hero";
import AccordionRow from "/components/accordionRow";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class CoreFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "core-hero":
				return new CoreHero(block);
			case "accordion-row":
				return new AccordionRow(block);
			default:
				return null;
		}
	}
}

new CoreFactory();
